import React, { createContext, useContext, useState } from "react";

interface SidebarContextType {
  isCompact: boolean;
  toggleCompact: () => void;
}

const SidebarContext = createContext<SidebarContextType | undefined>(undefined);

export const SidebarProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [isCompact, setIsCompact] = useState(false);

  const toggleCompact = () => {
    setIsCompact((prev) => !prev);
  };

  return (
    <SidebarContext.Provider value={{ isCompact, toggleCompact }}>
      {children}
    </SidebarContext.Provider>
  );
};

export const useSidebar = () => {
  const context = useContext(SidebarContext);
  if (context === undefined) {
    throw new Error("useSidebar must be used within a SidebarProvider");
  }
  return context;
};
